import ResourceManager from "@/components/admin/ResourceManager";
import { Field, Toggle } from "@/components/admin/Primitives";

export default function Notifications() {
  return (
    <ResourceManager
      resource="notifications"
      title="Notification Ticker"
      subtitle="The scrolling red band under the hero. Add short, punchy announcements."
      defaults={{ text: "", link: "/events", is_active: true, order: 0 }}
      columns={[
        { key: "text", label: "Text" },
        { key: "link", label: "Link" },
        { key: "order", label: "Order" },
        { key: "is_active", label: "Active" },
      ]}
      renderForm={(form, setForm) => (
        <>
          <Field label="Message" value={form.text} onChange={(v) => setForm({ ...form, text: v })} required testid="notif-text" placeholder="Premier League Final · Saturday 8 PM · Book Now" />
          <Field label="Link (where clicking should go)" value={form.link} onChange={(v) => setForm({ ...form, link: v })} testid="notif-link" placeholder="/events" />
          <Field label="Display order" type="number" value={form.order} onChange={(v) => setForm({ ...form, order: v })} testid="notif-order" />
          <Toggle label="Active" checked={form.is_active} onChange={(v) => setForm({ ...form, is_active: v })} testid="notif-active" />
        </>
      )}
    />
  );
}
